import { createBrowserHistory } from 'history'
import { applyMiddleware, compose, createStore } from 'redux'
import { routerMiddleware } from 'connected-react-router'
import thunk from 'redux-thunk'
import { getReducers } from './combine.js'

export const history = createBrowserHistory()
const composeEnhancers = (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

export default function configureStore() {
    const store = createStore(
        getReducers(history),
        composeEnhancers(applyMiddleware(routerMiddleware(history), thunk)),

    );
    return store;
}